import "./Blog.css";
import { FaCalendarAlt, FaUserAlt, FaArrowRight } from "react-icons/fa";

function Blog() {
  return (
    <>

      {/* =====================================
                HERO SECTION
      ===================================== */}

      <section
        className="cc-blog-hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1920&q=80')",
        }}
      >
        <div className="cc-blog-overlay">

          <span className="cc-blog-subtitle">
            InteriorMart Insights
          </span>

          <h1>
            Real Estate News &
            <br />
            Property Insights
          </h1>

          <p>
            Stay updated with the latest property trends, investment
            opportunities, home buying tips and expert real estate
            advice from InteriorMart professionals.
          </p>

          <button>
            Explore Articles
          </button>

        </div>
      </section>

      {/* =====================================
             FEATURED BLOG
      ===================================== */}

      <section className="cc-blog-featured">

        <div className="cc-blog-featured-left">

          <img
            src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80"
            alt="featured"
          />

        </div>

        <div className="cc-blog-featured-right">

          <span>FEATURED ARTICLE</span>

          <h2>
            10 Things Every First-Time
            Home Buyer Should Know
          </h2>

          <div className="cc-blog-meta">

            <span>

              <FaCalendarAlt />

              July 15, 2026

            </span>

            <span>

              <FaUserAlt />

              InteriorMart Team

            </span>

          </div>

          <p>

            Buying your first home is one of the biggest financial
            decisions you'll ever make. From understanding market
            trends to securing financing and choosing the right
            neighborhood, every step matters.

          </p>

          <p>

            In this guide, our experts share practical advice,
            common mistakes to avoid and insider tips to help
            you confidently purchase your dream property.

          </p>

          <button>

            Read Full Article

            <FaArrowRight />

          </button>

        </div>

      </section>

      {/* =====================================
            LATEST ARTICLES
===================================== */}

<section className="cc-blog-latest">

  <div className="cc-blog-heading">

    <span>OUR BLOG</span>

    <h2>Latest Articles</h2>

    <p>
      Explore our latest blogs covering real estate trends,
      investment opportunities, home décor ideas and property
      buying guides.
    </p>

  </div>

  <div className="cc-blog-grid">

    {/* CARD 1 */}

    <div className="cc-blog-card">

      <div className="cc-blog-card-img">

        <img
          src="https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=900&q=80"
          alt=""
        />

      </div>

      <div className="cc-blog-card-content">

        <div className="cc-blog-card-meta">

          <span>
            <FaCalendarAlt /> July 10, 2026
          </span>

          <span>
            <FaUserAlt /> Admin
          </span>

        </div>

        <h3>
          Modern Home Design Trends
          You Should Follow
        </h3>

        <p>
          Discover elegant architecture, luxury interiors
          and modern design ideas for your dream home.
        </p>

        <button>

          Read More

          <FaArrowRight />

        </button>

      </div>

    </div>

    {/* CARD 2 */}

    <div className="cc-blog-card">

      <div className="cc-blog-card-img">

        <img
          src="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80"
          alt=""
        />

      </div>

      <div className="cc-blog-card-content">

        <div className="cc-blog-card-meta">

          <span>
            <FaCalendarAlt /> July 08, 2026
          </span>

          <span>
            <FaUserAlt /> Admin
          </span>

        </div>

        <h3>
          Best Investment Properties
          in 2026
        </h3>

        <p>
          Learn which locations are giving the highest
          return on investment this year.
        </p>

        <button>

          Read More

          <FaArrowRight />

        </button>

      </div>

    </div>

    {/* CARD 3 */}

    <div className="cc-blog-card">

      <div className="cc-blog-card-img">

        <img
          src="https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=900&q=80"
          alt=""
        />

      </div>

      <div className="cc-blog-card-content">

        <div className="cc-blog-card-meta">

          <span>
            <FaCalendarAlt /> July 05, 2026
          </span>

          <span>
            <FaUserAlt /> Admin
          </span>

        </div>

        <h3>
          Interior Decoration Ideas
          for Small Homes
        </h3>

        <p>
          Maximize your home space with smart furniture
          and stylish decoration techniques.
        </p>

        <button>

          Read More

          <FaArrowRight />

        </button>

      </div>

    </div>

    {/* CARD 4 */}

    <div className="cc-blog-card">

      <div className="cc-blog-card-img">

        <img
          src="https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80"
          alt=""
        />

      </div>

      <div className="cc-blog-card-content">

        <div className="cc-blog-card-meta">

          <span>
            <FaCalendarAlt /> July 03, 2026
          </span>

          <span>
            <FaUserAlt /> Admin
          </span>

        </div>

        <h3>
          Kitchen Renovation Tips
          for Every Budget
        </h3>

        <p>
          Transform your kitchen into a modern and
          functional living space.
        </p>

        <button>

          Read More

          <FaArrowRight />

        </button>

      </div>

    </div>

    {/* CARD 5 */}

    <div className="cc-blog-card">

      <div className="cc-blog-card-img">

        <img
          src="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80"
          alt=""
        />

      </div>

      <div className="cc-blog-card-content">

        <div className="cc-blog-card-meta">

          <span>
            <FaCalendarAlt /> June 30, 2026
          </span>

          <span>
            <FaUserAlt /> Admin
          </span>

        </div>

        <h3>
          Luxury Apartments vs
          Independent Houses
        </h3>

        <p>
          Compare both property options before making
          your next investment decision.
        </p>

        <button>

          Read More

          <FaArrowRight />

        </button>

      </div>

    </div>

    {/* CARD 6 */}

    <div className="cc-blog-card">

      <div className="cc-blog-card-img">

        <img
          src="https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=900&q=80"
          alt=""
        />

      </div>

      <div className="cc-blog-card-content">

        <div className="cc-blog-card-meta">

          <span>
            <FaCalendarAlt /> June 28, 2026
          </span>

          <span>
            <FaUserAlt /> Admin
          </span>

        </div>

        <h3>
          Property Buying Checklist
          Every Buyer Needs
        </h3>

        <p>
          Essential documents and legal checks before
          purchasing your dream property.
        </p>

        <button>

          Read More

          <FaArrowRight />

        </button>

      </div>

    </div>

  </div>

</section>


{/* =====================================
        PROPERTY TIPS & SIDEBAR
===================================== */}

<section className="cc-blog-info-section">

  {/* LEFT SIDE */}

  <div className="cc-blog-left">

    <div className="cc-blog-tips">

      <span>PROPERTY TIPS</span>

      <h2>
        Smart Tips Before Buying
        Your Dream Property
      </h2>

      <p>
        Purchasing a property is one of the biggest financial
        decisions in life. Proper planning can help you avoid
        costly mistakes and secure the perfect investment.
      </p>

      <ul>

        <li>
          ✔ Always verify all legal property documents.
        </li>

        <li>
          ✔ Check the builder's reputation and project history.
        </li>

        <li>
          ✔ Compare prices in nearby locations before investing.
        </li>

        <li>
          ✔ Inspect construction quality personally.
        </li>

        <li>
          ✔ Choose locations with future development potential.
        </li>

        <li>
          ✔ Review loan eligibility and EMI affordability.
        </li>

      </ul>

      <button>
        Learn More
      </button>

    </div>

  </div>



  {/* RIGHT SIDE */}

  <div className="cc-blog-right">

    {/* Categories */}

    <div className="cc-blog-sidebar-box">

      <h3>Categories</h3>

      <ul>

        <li>Real Estate (18)</li>

        <li>Property Investment (10)</li>

        <li>Interior Design (15)</li>

        <li>Home Decoration (12)</li>

        <li>Buying Guide (09)</li>

        <li>Construction (08)</li>

      </ul>

    </div>



    {/* Recent Posts */}

    <div className="cc-blog-sidebar-box">

      <h3>Recent Posts</h3>

      <div className="cc-blog-recent-post">

        <img
          src="https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=300&q=80"
          alt=""
        />

        <div>

          <h4>
            Modern Villa Design Ideas
          </h4>

          <span>July 18, 2026</span>

        </div>

      </div>

      <div className="cc-blog-recent-post">

        <img
          src="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=300&q=80"
          alt=""
        />

        <div>

          <h4>
            Best Investment Locations
          </h4>

          <span>July 14, 2026</span>

        </div>

      </div>

      <div className="cc-blog-recent-post">

        <img
          src="https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=300&q=80"
          alt=""
        />

        <div>

          <h4>
            Kitchen Renovation Guide
          </h4>

          <span>July 09, 2026</span>

        </div>

      </div>

    </div>



    {/* Popular Tags */}

    <div className="cc-blog-sidebar-box">

      <h3>Popular Tags</h3>

      <div className="cc-blog-tags">

        <span>Apartment</span>

        <span>Villa</span>

        <span>Luxury</span>

        <span>Investment</span>

        <span>Interior</span>

        <span>Commercial</span>

        <span>Decoration</span>

        <span>Architecture</span>

      </div>

    </div>

  </div>

</section>

{/* =====================================
          NEWSLETTER SECTION
===================================== */}

<section
  className="cc-blog-newsletter"
  style={{
    backgroundImage:
      "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1920&q=80')",
  }}
>

  <div className="cc-blog-newsletter-overlay">

    <span>SUBSCRIBE NOW</span>

    <h2>
      Never Miss Our Latest
      Property Updates
    </h2>

    <p>
      Subscribe to our newsletter and receive the latest
      real estate news, market trends, investment tips
      and exclusive property offers directly in your inbox.
    </p>

    <div className="cc-blog-newsletter-form">

      <input
        type="email"
        placeholder="Enter Your Email Address"
      />

      <button>
        Subscribe Now
      </button>

    </div>

  </div>

</section>



{/* =====================================
            CALL TO ACTION
===================================== */}

<section className="cc-blog-cta">

  <div className="cc-blog-cta-content">

    <span>START TODAY</span>

    <h2>
      Looking For Your Dream Property?
    </h2>

    <p>
      Let InteriorMart help you discover premium residential,
      commercial and investment properties across the best
      locations with trusted professionals.
    </p>

    <div className="cc-blog-cta-buttons">

      <button className="cc-blog-btn-one">
        Explore Properties
      </button>

      <button className="cc-blog-btn-two">
        Contact Our Experts
      </button>

    </div>

  </div>

</section>

    </>
  );
}

export default Blog;
    